module.exports = __webpack_public_path__ + "img/SKMJ_protect.d3acdc0d.png";